import { render, staticRenderFns } from "./ResultsSlide.vue?vue&type=template&id=0735b7c6&scoped=true"
import script from "./ResultsSlide.vue?vue&type=script&lang=js"
export * from "./ResultsSlide.vue?vue&type=script&lang=js"
import style0 from "./ResultsSlide.vue?vue&type=style&index=0&id=0735b7c6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0735b7c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0735b7c6')) {
      api.createRecord('0735b7c6', component.options)
    } else {
      api.reload('0735b7c6', component.options)
    }
    module.hot.accept("./ResultsSlide.vue?vue&type=template&id=0735b7c6&scoped=true", function () {
      api.rerender('0735b7c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/slides/ResultsSlide.vue"
export default component.exports